export default __webpack_public_path__ + "static/media/backgroundChat.a1a69318.mp4";